import {Word} from "./Word";
import { Example } from "./Example";

 export class Proposition extends Word {
    public examples : Array<Example>;
    public example : Example;
    constructor(word:any){
        super(word);
        this.examples = [];
        this.name = word.proposition;
        this.word = word.word;
        this.example = new Example({'sentence':word.example});
        // for (let example of word.examples){
        //     this.examples.push(new Example(example));
        // }
    }
}